import { Button, Modal } from "antd";
import React, { useEffect, useState } from "react";
import { apiUrl } from "../../../../providers/companyInfo";

export default function ModalExamStatusReport(props) {
	const {
		tableFilter,
		toggleModalExamStatusReport,
		setToggleModalExamStatusReport,
	} = props;

	const [pdfUrl, setPdfUrl] = useState(null);

	useEffect(() => {
		if (toggleModalExamStatusReport.open && toggleModalExamStatusReport.data) {
			const url = apiUrl(
				`api/report_exam_status_pdf?${new URLSearchParams(tableFilter)}`
			);

			setPdfUrl(url);
		}
	}, [toggleModalExamStatusReport]);

	return (
		<Modal
			wrapClassName="modal-wrap-exam-status-report-preview"
			title="Exam Status Report Preview"
			width={900}
			open={toggleModalExamStatusReport.open}
			onCancel={() => {
				setToggleModalExamStatusReport({
					open: false,
					data: null,
				});
				setPdfUrl(null);
			}}
			footer={[
				<Button
					className="btn-main-primary outlined"
					key={1}
					onClick={() => {
						setToggleModalExamStatusReport({
							open: false,
							data: null,
						});
						setPdfUrl(null);
					}}
				>
					CLOSE
				</Button>,
			]}
		>
			{pdfUrl ? (
				<iframe src={pdfUrl} frameBorder="0" width="100%" height="600px" />
			) : (
				<div style={{ textAlign: "center", padding: "20px" }}>No Data</div>
			)}
		</Modal>
	);
}
